export default "__VITE_ASSET__CDyUJa3N__"